var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoinLocked = function SvgCoinLocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__a)",
    d: "M34.047 23.956v-2.373l-16.971 1.373v2.438c.01 1.116.69 2.18 2.07 2.978 3.069 1.771 8.428 1.55 11.97-.496 1.943-1.122 2.936-2.559 2.931-3.92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__b)",
    d: "m33.346 21.64-4.057.328v6.75a11.5 11.5 0 0 0 1.828-.843c.994-.573 1.738-1.23 2.229-1.916z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__c)",
    d: "M17.072 25.37v.036c.01 1.061.625 2.076 1.872 2.858l2.434-1.406-2.836-4.008-1.47.119z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__d)",
    d: "M31.117 25.488c3.543-2.046 3.927-5.14.86-6.911-3.069-1.772-8.428-1.55-11.97.496-3.544 2.045-3.928 5.14-.86 6.91 3.068 1.772 8.427 1.55 11.97-.495"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__e)",
    d: "M31.312 18.96c-2.75-1.587-7.554-1.388-10.73.445-3.176 1.834-3.52 4.607-.77 6.195s7.554 1.389 10.73-.445c3.175-1.833 3.52-4.607.77-6.195m-1.526 5.76c-2.694 1.555-6.77 1.724-9.102.377s-2.04-3.7.653-5.256c2.694-1.555 6.77-1.724 9.102-.377s2.04 3.7-.653 5.255"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__f)",
    d: "M20.582 19.619c3.175-1.834 7.98-2.033 10.73-.445 1.202.694 1.812 1.615 1.854 2.584.045-1.047-.564-2.053-1.854-2.797-2.75-1.588-7.555-1.39-10.73.444-1.788 1.032-2.678 2.362-2.625 3.611.05-1.185.939-2.424 2.625-3.397"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__g)",
    d: "M20.684 25.31c2.333 1.346 6.408 1.177 9.102-.378 1.524-.88 2.28-2.015 2.225-3.08-.05 1.001-.803 2.045-2.225 2.866-2.694 1.556-6.77 1.725-9.102.378-1.013-.585-1.53-1.36-1.572-2.176-.045.894.47 1.754 1.572 2.39"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__h)",
    d: "M19.143 25.995c.654.378 1.412.664 2.235.862h1.738v-5.66H17.64c-1.091 1.708-.624 3.57 1.502 4.798"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__i)",
    d: "M32.877 21.246v-2.373l-16.972 1.373v2.437c.01 1.117.691 2.182 2.072 2.979 3.068 1.771 8.427 1.549 11.97-.496 1.942-1.122 2.935-2.559 2.93-3.92"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__j)",
    d: "M27.26 26.287c.958-.276 1.87-.65 2.686-1.12a8.3 8.3 0 0 0 1.37-.976V19l-4.056.328z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__k)",
    d: "M15.898 22.65v.034c.01 1.117.69 2.182 2.07 2.979q.144.082.294.16l2.663-1.538-2.276-4.26-2.751.222z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__l)",
    d: "M29.946 22.778c3.543-2.045 3.928-5.14.86-6.91-3.069-1.772-8.428-1.55-11.97.496-3.543 2.045-3.928 5.14-.86 6.91 3.068 1.772 8.427 1.55 11.97-.496"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__m)",
    d: "M30.141 16.25c-2.75-1.588-7.554-1.389-10.73.445-3.175 1.833-3.52 4.607-.77 6.195s7.554 1.389 10.73-.445 3.52-4.607.77-6.195m-1.525 5.759c-2.694 1.555-6.77 1.724-9.103.377s-2.04-3.7.654-5.255 6.769-1.724 9.102-.377 2.04 3.7-.653 5.255"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__n)",
    d: "M19.411 16.908c3.176-1.833 7.98-2.032 10.73-.444 1.202.694 1.813 1.614 1.855 2.584.044-1.047-.565-2.053-1.855-2.798-2.75-1.588-7.554-1.389-10.73.445-1.787 1.032-2.678 2.362-2.624 3.61.05-1.185.938-2.423 2.624-3.397"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__o)",
    d: "M19.513 22.6c2.333 1.346 6.408 1.178 9.102-.378 1.525-.88 2.28-2.015 2.226-3.079-.05 1-.803 2.044-2.226 2.866-2.694 1.555-6.769 1.724-9.102.377-1.013-.585-1.53-1.36-1.572-2.176-.045.894.471 1.754 1.572 2.39"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__p)",
    d: "M23.556 16.473s-2.612.016-4.95.021c-3.335 2.045-3.64 5.045-.637 6.779.841.485 1.855.82 2.956 1.01h3.023z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__q)",
    d: "M33.777 18.684v-2.373l-16.972 1.374v2.437c.01 1.116.69 2.181 2.071 2.978 3.068 1.771 8.427 1.55 11.97-.496 1.943-1.122 2.936-2.558 2.93-3.92"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__r)",
    d: "M28.13 23.733c.969-.276 1.892-.654 2.716-1.13.514-.296.96-.615 1.34-.948v-5.216l-4.056.329z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__s)",
    d: "M16.805 20.087v.035c.01 1.062.625 2.076 1.872 2.858l2.434-1.405-.95-4.161-3.356.271z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__t)",
    d: "M30.846 20.215c3.543-2.045 3.928-5.14.86-6.91-3.068-1.772-8.428-1.55-11.97.495-3.543 2.046-3.928 5.14-.86 6.911 3.068 1.772 8.427 1.55 11.97-.496"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__u)",
    d: "M31.041 13.688c-2.75-1.587-7.554-1.388-10.73.445-3.176 1.834-3.52 4.607-.77 6.195s7.554 1.389 10.73-.445c3.175-1.833 3.52-4.607.77-6.195m-1.526 5.76c-2.694 1.555-6.769 1.723-9.102.377-2.333-1.348-2.04-3.7.654-5.256 2.694-1.555 6.769-1.724 9.102-.377s2.04 3.7-.654 5.255"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__v)",
    d: "M20.311 14.347c3.176-1.834 7.98-2.033 10.73-.445 1.202.694 1.813 1.615 1.854 2.584.045-1.047-.564-2.053-1.854-2.798-2.75-1.587-7.554-1.388-10.73.445-1.788 1.032-2.678 2.362-2.625 3.611.051-1.185.94-2.424 2.625-3.397"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__w)",
    d: "M20.413 20.037c2.333 1.347 6.408 1.178 9.102-.377 1.524-.88 2.28-2.015 2.226-3.08-.05 1.001-.803 2.045-2.226 2.866-2.694 1.556-6.769 1.725-9.102.378-1.013-.585-1.53-1.36-1.572-2.176-.045.894.471 1.754 1.572 2.39"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__x)",
    d: "m23.292 14.875-4.497-.452c-2.644 2.01-2.69 4.689.081 6.289.654.377 1.413.664 2.235.862h4.012z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__y)",
    d: "M34.737 15.961v-2.373l-16.971 1.374v2.437c.01 1.116.69 2.181 2.07 2.978 3.069 1.771 8.428 1.55 11.97-.496 1.943-1.122 2.936-2.559 2.931-3.92"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__z)",
    d: "m34.022 13.647-4.057.328v6.754a11.5 11.5 0 0 0 1.842-.847c.985-.569 1.725-1.218 2.215-1.898z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__A)",
    d: "M17.766 17.365v.035c.008.898.45 1.763 1.34 2.481l2.173-1.254-2.618-3.736-.895.072z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__B)",
    d: "M31.807 17.493c3.543-2.046 3.927-5.14.86-6.911-3.069-1.772-8.428-1.55-11.97.496-3.543 2.045-3.928 5.14-.86 6.911s8.427 1.55 11.97-.496"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__C)",
    d: "M32.002 10.966c-2.75-1.588-7.555-1.389-10.73.445-3.176 1.833-3.52 4.607-.77 6.195 2.75 1.587 7.554 1.388 10.73-.445 3.175-1.834 3.52-4.607.77-6.195m-1.526 5.759c-2.694 1.555-6.77 1.724-9.102.377s-2.04-3.7.653-5.255c2.694-1.556 6.77-1.724 9.102-.377s2.04 3.7-.653 5.255"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__D)",
    d: "M21.272 11.624c3.176-1.833 7.98-2.032 10.73-.445 1.202.694 1.812 1.615 1.854 2.585.045-1.048-.564-2.053-1.854-2.798-2.75-1.588-7.555-1.389-10.73.445-1.788 1.032-2.678 2.362-2.625 3.61.05-1.185.939-2.423 2.625-3.397"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__E)",
    d: "M21.374 17.315c2.333 1.347 6.408 1.178 9.102-.377 1.524-.88 2.28-2.015 2.225-3.08-.05 1.001-.803 2.045-2.225 2.866-2.694 1.556-6.77 1.725-9.102.378-1.013-.585-1.53-1.36-1.572-2.176-.045.894.47 1.754 1.572 2.39"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__F)",
    d: "M19.837 17.99c.438.252.922.465 1.442.637h2.669l-6.182-3.673c-.014 1.137.667 2.225 2.07 3.036"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__G)",
    d: "M33.777 13.027v-2.373l-16.972 1.373v2.437c.01 1.117.69 2.182 2.071 2.978 3.068 1.772 8.427 1.55 11.97-.496 1.943-1.121 2.936-2.558 2.93-3.92"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__H)",
    d: "m32.704 10.74-4.057.329v6.848c.78-.257 1.523-.58 2.2-.97.769-.445 1.389-.94 1.857-1.458z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__I)",
    d: "M30.846 14.557c3.543-2.045 3.928-5.14.86-6.91-3.068-1.772-8.428-1.55-11.97.495-3.543 2.046-3.928 5.14-.86 6.911 3.068 1.772 8.427 1.55 11.97-.496"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__J)",
    d: "M31.706 7.646c-3.068-1.771-8.428-1.549-11.97.497-3.543 2.045-3.928 5.139-.86 6.91q.154.09.315.17L32 7.829a6 6 0 0 0-.295-.182"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__K)",
    d: "M31.041 8.03c-2.75-1.587-7.554-1.388-10.73.445-3.176 1.834-3.52 4.608-.77 6.195s7.554 1.39 10.73-.444c3.175-1.834 3.52-4.607.77-6.195m-1.526 5.76c-2.694 1.555-6.769 1.724-9.102.377s-2.04-3.7.654-5.255c2.694-1.556 6.769-1.725 9.102-.378s2.04 3.7-.654 5.255"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__L)",
    d: "M20.311 8.689c3.176-1.833 7.98-2.033 10.73-.445 1.202.694 1.813 1.615 1.854 2.584.045-1.047-.564-2.052-1.854-2.797-2.75-1.588-7.554-1.389-10.73.444-1.788 1.033-2.678 2.363-2.625 3.611.051-1.185.94-2.424 2.625-3.397"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__M)",
    d: "M20.413 14.38c2.333 1.347 6.408 1.179 9.102-.377 1.524-.88 2.28-2.015 2.226-3.079-.05 1-.803 2.044-2.226 2.866-2.694 1.555-6.769 1.724-9.102.377-1.013-.585-1.53-1.36-1.572-2.176-.045.894.471 1.754 1.572 2.39"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__N)",
    d: "M30.394 28.337h-9.975a.83.83 0 0 1-.836-.827v-2.222c0-.456.375-.826.836-.826h9.975c.462 0 .836.37.836.826v2.222a.83.83 0 0 1-.836.827"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__O)",
    d: "M19.503 20.156c-.71 0-1.287-.57-1.287-1.27v-4.088c0-2.15-1.77-3.898-3.945-3.898s-3.944 1.749-3.944 3.898v4.087c0 .702-.576 1.271-1.286 1.271s-1.287-.57-1.287-1.27v-4.088c0-3.55 2.924-6.44 6.518-6.44s6.517 2.89 6.517 6.44v4.087c0 .702-.576 1.271-1.287 1.271"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__P)",
    d: "M14.272 8.358a6.6 6.6 0 0 0-1.006.077v2.594a4 4 0 0 1 1.006-.129c2.175 0 3.944 1.749 3.944 3.898v4.087c0 .702.576 1.271 1.287 1.271.71 0 1.286-.569 1.286-1.27v-4.088c0-3.551-2.924-6.44-6.517-6.44"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__Q)",
    d: "M18.216 14.798v4.087c0 .702.576 1.271 1.287 1.271.71 0 1.286-.57 1.286-1.271v-4.087a6.34 6.34 0 0 0-.78-3.053H16.72a3.88 3.88 0 0 1 1.496 3.053"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__R)",
    d: "M9.04 20.156c.71 0 1.287-.57 1.287-1.271v-4.087c0-1.236.585-2.338 1.496-3.053H8.534a6.34 6.34 0 0 0-.78 3.053v4.087c0 .702.576 1.271 1.287 1.271"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__S)",
    d: "M18.984 32.26H9.559c-2.852 0-5.083-2.428-4.808-5.233l.68-6.947c.24-2.447 2.32-4.314 4.808-4.314h8.065c2.488 0 4.569 1.867 4.808 4.314l.68 6.947c.275 2.804-1.956 5.233-4.808 5.233"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__T)",
    d: "M14.272 29.113c-1.497 0-2.714-1.202-2.714-2.68v-.671a3.93 3.93 0 0 1-1.281-3.02c.063-2.107 1.851-3.825 3.985-3.83 2.213 0 4.006 1.772 4.006 3.95a3.94 3.94 0 0 1-1.283 2.9v.67c0 1.479-1.217 2.681-2.713 2.681"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__U)",
    d: "M4.75 27.027c-.274 2.805 1.957 5.233 4.81 5.233h9.424c2.852 0 5.083-2.428 4.808-5.233l-.47-4.814h-18.1z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__V)",
    d: "M23.113 20.08c-.24-2.447-2.321-4.314-4.81-4.314h-7.24V32.26h7.92c2.853 0 5.084-2.428 4.81-5.233z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__W)",
    d: "M16.93 22.862c0-1.453-1.194-2.63-2.665-2.627-1.424.003-2.608 1.14-2.65 2.546-.025.796.31 1.515.854 2.011.27.246.427.588.427.95v.69c0 .75.616 1.359 1.375 1.359.76 0 1.375-.608 1.375-1.359v-.69c0-.359.153-.7.42-.943.531-.48.864-1.17.864-1.937"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__X)",
    d: "M16.93 22.862c0-1.453-1.194-2.63-2.665-2.627-1.424.003-2.608 1.14-2.65 2.546-.025.796.31 1.515.854 2.011.27.246.427.588.427.95v.69c0 .75.616 1.359 1.375 1.359.76 0 1.375-.608 1.375-1.359v-.69c0-.359.153-.7.42-.943.531-.48.864-1.17.864-1.937"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinLocked_svg__Y)",
    d: "M16.93 22.862c0-1.453-1.194-2.63-2.665-2.627-1.424.003-2.608 1.14-2.65 2.546-.025.796.31 1.515.854 2.011.27.246.427.588.427.95v.69c0 .75.616 1.359 1.375 1.359.76 0 1.375-.608 1.375-1.359v-.69c0-.359.153-.7.42-.943.531-.48.864-1.17.864-1.937"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__a",
    x1: 16.915,
    x2: 32.408,
    y1: 25.575,
    y2: 25.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA5C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222,
    stopColor: "#FFC538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    stopColor: "#FFA538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#FBC23C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#F8D840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F7E041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752,
    stopColor: "#F9D53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915,
    stopColor: "#FDB73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__b",
    x1: 33.615,
    x2: 28.221,
    y1: 22.951,
    y2: 26.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__c",
    x1: 18.409,
    x2: 20.986,
    y1: 25.081,
    y2: 29.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B451C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B451C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__d",
    x1: 23.049,
    x2: 33.514,
    y1: 21.051,
    y2: 26.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E37A34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#FFA538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#FFC538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__e",
    x1: 33.974,
    x2: 17.883,
    y1: 27.235,
    y2: 17.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E37A34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#FFA538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#FFC538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__f",
    x1: 30.576,
    x2: 14.883,
    y1: 24.487,
    y2: 15.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA5C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#FFC538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFA538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#F7E041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__g",
    x1: 29.504,
    x2: 16.183,
    y1: 25.44,
    y2: 17.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA5C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#FFC538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFA538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#F7E041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__h",
    x1: 19.882,
    x2: 14.838,
    y1: 24.314,
    y2: 27.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B451C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B451C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__i",
    x1: 13.104,
    x2: 28.597,
    y1: 22.865,
    y2: 22.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA5C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222,
    stopColor: "#FFC538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    stopColor: "#FFA538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#FBC23C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#F8D840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F7E041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#F9D53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#FDB73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#FFA538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__j",
    x1: 32.011,
    x2: 27.504,
    y1: 20.28,
    y2: 22.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__k",
    x1: 16.776,
    x2: 19.581,
    y1: 20.855,
    y2: 25.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B451C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B451C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__l",
    x1: 21.878,
    x2: 32.344,
    y1: 18.342,
    y2: 23.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E37A34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#FFA538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#FFC538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__m",
    x1: 32.804,
    x2: 16.712,
    y1: 24.524,
    y2: 15.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.022,
    stopColor: "#FFC538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.263,
    stopColor: "#FFA538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#F7E041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__n",
    x1: 29.405,
    x2: 13.713,
    y1: 21.776,
    y2: 12.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA5C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#FFC538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFA538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#F7E041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__o",
    x1: 28.334,
    x2: 15.013,
    y1: 22.73,
    y2: 14.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA5C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#FFC538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFA538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#F7E041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__p",
    x1: 20.345,
    x2: 12.073,
    y1: 20.927,
    y2: 25.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B451C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B451C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__q",
    x1: 16.644,
    x2: 32.138,
    y1: 20.303,
    y2: 20.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA5C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222,
    stopColor: "#FFC538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    stopColor: "#FFA538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#FBC23C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F8D840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496,
    stopColor: "#F7E041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#F9D53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#FDB73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__r",
    x1: 32.882,
    x2: 28.969,
    y1: 17.726,
    y2: 19.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__s",
    x1: 16.549,
    x2: 20.727,
    y1: 15.78,
    y2: 23.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B451C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B451C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__t",
    x1: 22.778,
    x2: 33.244,
    y1: 15.778,
    y2: 20.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E37A34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#FFA538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#FFC538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__u",
    x1: 33.704,
    x2: 17.612,
    y1: 21.963,
    y2: 12.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.022,
    stopColor: "#FFC538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.263,
    stopColor: "#FFA538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#F7E041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__v",
    x1: 30.305,
    x2: 14.612,
    y1: 19.215,
    y2: 9.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA5C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#FFC538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFA538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#F7E041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__w",
    x1: 29.233,
    x2: 15.913,
    y1: 20.168,
    y2: 12.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA5C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#FFC538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFA538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#F7E041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__x",
    x1: 23.824,
    x2: 11.081,
    y1: 16.922,
    y2: 24.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B451C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B451C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__y",
    x1: 18.281,
    x2: 33.775,
    y1: 17.58,
    y2: 17.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA5C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222,
    stopColor: "#FFC538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    stopColor: "#FFA538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#FBC23C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    stopColor: "#F8D840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    stopColor: "#F7E041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.814,
    stopColor: "#F9D53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936,
    stopColor: "#FDB73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__z",
    x1: 33.965,
    x2: 29.939,
    y1: 15.151,
    y2: 17.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__A",
    x1: 18.002,
    x2: 20.302,
    y1: 15.742,
    y2: 19.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B451C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B451C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__B",
    x1: 23.739,
    x2: 34.204,
    y1: 13.056,
    y2: 18.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7E041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__C",
    x1: 34.664,
    x2: 18.573,
    y1: 19.24,
    y2: 9.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E37A34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#FFA538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#FFC538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__D",
    x1: 31.265,
    x2: 15.573,
    y1: 16.492,
    y2: 7.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA5C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#FFC538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFA538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#F7E041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__E",
    x1: 30.194,
    x2: 16.873,
    y1: 17.446,
    y2: 9.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA5C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#FFC538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFA538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#F7E041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__F",
    x1: 22.064,
    x2: 17.384,
    y1: 16.093,
    y2: 18.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B451C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B451C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__G",
    x1: 19.8,
    x2: 35.294,
    y1: 14.646,
    y2: 14.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA5C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222,
    stopColor: "#FFC538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    stopColor: "#FFA538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#FBC23C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#F8D840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F7E041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752,
    stopColor: "#F9D53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915,
    stopColor: "#FDB73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__H",
    x1: 32.646,
    x2: 27.944,
    y1: 12.334,
    y2: 15.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__I",
    x1: 18.569,
    x2: 24.855,
    y1: 15.228,
    y2: 4.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7E041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__J",
    x1: 26.588,
    x2: 24.274,
    y1: 14.098,
    y2: 10.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__K",
    x1: 33.704,
    x2: 18.499,
    y1: 16.305,
    y2: 7.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E37A34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#FFA538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#FFC538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__L",
    x1: 30.305,
    x2: 14.612,
    y1: 13.557,
    y2: 4.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA5C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#FFC538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFA538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#F7E041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__M",
    x1: 29.233,
    x2: 15.913,
    y1: 14.511,
    y2: 6.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA5C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#FFC538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFA538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#F7E041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__N",
    x1: 26.312,
    x2: 24.206,
    y1: 27.634,
    y2: 24.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#FDA215",
    stopOpacity: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#FB961B",
    stopOpacity: 0.405
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607,
    stopColor: "#F68225",
    stopOpacity: 0.607
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807,
    stopColor: "#F06633",
    stopOpacity: 0.807
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__O",
    x1: 35.371,
    x2: 11.537,
    y1: 20.951,
    y2: 5.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E5BCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D76DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__P",
    x1: 18.971,
    x2: 20.624,
    y1: 14.002,
    y2: 13.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#619FE9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3166EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__Q",
    x1: 18.754,
    x2: 18.754,
    y1: 13.882,
    y2: 16.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2881D2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27569D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__R",
    x1: 9.789,
    x2: 9.789,
    y1: 13.882,
    y2: 16.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153A71",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11599B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__S",
    x1: 9.168,
    x2: 19.303,
    y1: 22.105,
    y2: 33.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ECCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C96F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__T",
    x1: 27.212,
    x2: 10.045,
    y1: 29.801,
    y2: 21.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2559A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10427C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__U",
    x1: 14.271,
    x2: 14.271,
    y1: 27.003,
    y2: 31.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70B2FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6099"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__V",
    x1: 19.154,
    x2: 23.037,
    y1: 23.746,
    y2: 23.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57AFF9",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C5F98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__W",
    x1: 12.135,
    x2: 15.733,
    y1: 22.434,
    y2: 24.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__X",
    x1: 15.576,
    x2: 12.531,
    y1: 23.519,
    y2: 24.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#403C40",
    stopOpacity: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#363336",
    stopOpacity: 0.622
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#252425",
    stopOpacity: 0.876
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinLocked_svg__Y",
    x1: 15.056,
    x2: 12.678,
    y1: 24.666,
    y2: 21.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#403C40",
    stopOpacity: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#363336",
    stopOpacity: 0.622
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#252425",
    stopOpacity: 0.876
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })))));
};
export default SvgCoinLocked;